/* eslint-disable no-restricted-globals */
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { printerQueueSelector, removeQueueFromPrinter } from 'src/features/printer/store';
import { useTranslation } from 'react-i18next';
import { TablePrintContent } from '../TablePrintContent';
import { IdModel } from 'src/types';

type Props = {
  printerIsReady:boolean;
  onPrint:(doc:string, id:IdModel)=>void;
};

export const QueuedPrinter: React.FC<Props> = ({printerIsReady, onPrint}) => {
  const queues = useSelector(printerQueueSelector);
  const {t} = useTranslation();

  const dispatch = useDispatch();

  const onCancel = useCallback(
    (id: string) =>  {
      dispatch(removeQueueFromPrinter({ id }));
    },
    [dispatch],
  );


  if (!queues.length) {
    return null;
  }

  return (
    <section className="container mx-auto p-6 font-mono">
        <div className='my-3 m-auto text-center'>
            <span className='text-xl text-primary'>{t('printer.print-queue-section-title')}</span>
        </div>
     

        <TablePrintContent data={queues} printerIsReady={printerIsReady} onPrint={onPrint}  onCancelPrint={onCancel} keysPrefix='queue-print-on-demand'/>
    </section>
  );
};
